import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { serverPath } from "config/config";

export const loginUser = createAsyncThunk(
  "auth/login",
  async ({ login, password }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${serverPath}/scripts/login.php`, {
        login,
        password,
      });

      if (!response.data.success) {
        // Изменено для более четкого сообщения об ошибке
        throw new Error(response.data.message || "Ошибка авторизации");
      }

      localStorage.setItem("authToken", response.data.token);
      return response.data;
    } catch (error) {
      // Улучшенная обработка ошибок
      const errorMessage =
        error.response?.data?.message || error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);
const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: !!localStorage.getItem("authToken"),
    isLoading: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      localStorage.removeItem("authToken");
      state.isAuthenticated = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state) => {
        state.isLoading = false;
        state.isAuthenticated = true;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
